import React from "react";
import Index from "../Components/LearnMore";

export default function LearnMore() {
  return <Index />;
}
